import React from "react";
import WithDefaults from "Shared/WithDefaults";

export interface LabelProps {
    label: string;
    prefix?: string;
    ticks: number[];
}

const defaultProps = {
    prefix: "",
};

const SliderLabels: React.FunctionComponent<LabelProps> = ({ prefix, ticks, label }: LabelProps) => {
    const listElements = ticks.map((tickValue) => (
        <li key={tickValue} className="OSSlider__tick">
            {prefix}
            {tickValue}
            {tickValue === 0 ? "" : label}
        </li>
    ));

    return <ul className="OSSlider__inputLabels">{listElements}</ul>;
};

export default WithDefaults(defaultProps, SliderLabels);
